export default "__VITE_ASSET__DD0f_E3S__"